// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + {"32":"1473ea45d598ad6ebbb0","967":"495b85915b849df29760"}[chunkId] + ".js";
};